export const MINUTES_PER_DAY = 1440;
export const TIMELINE_SEGMENTS = 96;

function clamp(value: number, min: number, max: number) {
  return Math.min(max, Math.max(min, value));
}

export function sliderPositionPercent(minute: number) {
  return (clamp(minute, 0, MINUTES_PER_DAY) / MINUTES_PER_DAY) * 100;
}

export function timelineTickPercent(tick: number) {
  return (clamp(tick, 0, TIMELINE_SEGMENTS) / TIMELINE_SEGMENTS) * 100;
}
